// removed by extract-text-webpack-plugin
module.exports = {"container":"ContactSearchSelection-container","iconContainer":"ContactSearchSelection-iconContainer"};